import Vue from 'vue'
import App from './App.vue'
import router from './router'

/* Plugins */
import './plugins'

/* utils */
import Request from '@/utils/request'

/* Styles */
import 'basscss/css/basscss-cp.min.css'
import '@/styles/index.css'

Vue.config.productionTip = false

Vue.prototype.$http = Request

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
